import { createFileRoute } from '@tanstack/react-router';
import { ProfileGuard } from '../components/auth/ProfileGuard';
import { MyTicketsPage } from '../components/tickets/MyTicketsPage';

export type TicketsSearch = {
  eventId?: string;
};

export const Route = createFileRoute('/tickets')({
  validateSearch: (search: Record<string, unknown>): TicketsSearch => ({
    eventId: typeof search.eventId === 'string' ? search.eventId : undefined,
  }),
  component: TicketsRoute,
});

function TicketsRoute() {
  const { eventId } = Route.useSearch();
  return (
    <ProfileGuard>
      <MyTicketsPage eventId={eventId} />
    </ProfileGuard>
  );
}
